/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_FormatInputs */

const th_event_format = /** @type {(inputs: Event_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รูปแบบ`)
};

const en_event_format = /** @type {(inputs: Event_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const ja_event_format = /** @type {(inputs: Event_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`形式`)
};

const zh_event_format = /** @type {(inputs: Event_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赛制`)
};

const es_event_format = /** @type {(inputs: Event_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato`)
};

const pt_event_format = /** @type {(inputs: Event_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato`)
};

const id_event_format = /** @type {(inputs: Event_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const fr_event_format = /** @type {(inputs: Event_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const tl_event_format = /** @type {(inputs: Event_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pormat`)
};

const vi_event_format = /** @type {(inputs: Event_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thể thức`)
};

const ko_event_format = /** @type {(inputs: Event_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`방식`)
};

const de_event_format = /** @type {(inputs: Event_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const ru_event_format = /** @type {(inputs: Event_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Формат`)
};

const tr_event_format = /** @type {(inputs: Event_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const it_event_format = /** @type {(inputs: Event_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato`)
};

const pl_event_format = /** @type {(inputs: Event_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const uk_event_format = /** @type {(inputs: Event_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Формат`)
};

const hi_event_format = /** @type {(inputs: Event_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रारूप`)
};

const ar_event_format = /** @type {(inputs: Event_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النظام`)
};

const ms_event_format = /** @type {(inputs: Event_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const bn_event_format = /** @type {(inputs: Event_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ধরন`)
};

const zh_tw2_event_format = /** @type {(inputs: Event_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`賽制`)
};

const zh_hk2_event_format = /** @type {(inputs: Event_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`賽制`)
};

const ur_event_format = /** @type {(inputs: Event_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`طریقہ`)
};

const fa_event_format = /** @type {(inputs: Event_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قالب`)
};

const sw_event_format = /** @type {(inputs: Event_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muundo`)
};

const nl_event_format = /** @type {(inputs: Event_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzet`)
};

/**
* | output |
* | --- |
* | "Format" |
*
* @param {Event_FormatInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_format = /** @type {((inputs?: Event_FormatInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_FormatInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_format(inputs)
	if (locale === "ja") return ja_event_format(inputs)
	if (locale === "zh") return zh_event_format(inputs)
	if (locale === "es") return es_event_format(inputs)
	if (locale === "pt") return pt_event_format(inputs)
	if (locale === "id") return id_event_format(inputs)
	if (locale === "fr") return fr_event_format(inputs)
	if (locale === "tl") return tl_event_format(inputs)
	if (locale === "vi") return vi_event_format(inputs)
	if (locale === "ko") return ko_event_format(inputs)
	if (locale === "de") return de_event_format(inputs)
	if (locale === "ru") return ru_event_format(inputs)
	if (locale === "tr") return tr_event_format(inputs)
	if (locale === "it") return it_event_format(inputs)
	if (locale === "pl") return pl_event_format(inputs)
	if (locale === "uk") return uk_event_format(inputs)
	if (locale === "hi") return hi_event_format(inputs)
	if (locale === "ar") return ar_event_format(inputs)
	if (locale === "ms") return ms_event_format(inputs)
	if (locale === "bn") return bn_event_format(inputs)
	if (locale === "zh-TW") return zh_tw2_event_format(inputs)
	if (locale === "zh-HK") return zh_hk2_event_format(inputs)
	if (locale === "ur") return ur_event_format(inputs)
	if (locale === "fa") return fa_event_format(inputs)
	if (locale === "sw") return sw_event_format(inputs)
	if (locale === "nl") return nl_event_format(inputs)
	return en_event_format(inputs)
});